import React from "react";
import { Space } from "antd";
import { GeoAltFill, TelephoneFill, EnvelopeAtFill, Globe } from "react-bootstrap-icons";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Footer = function Footer() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Common.account != 'undefined' && Common.account != null && /*#__PURE__*/_jsxs("div", {
      style: {
        background: "#D8C0C0",
        textAlign: "center",
        padding: "7px",
        borderRadius: "7px",
        color: "#433F3F"
      },
      children: [/*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(GeoAltFill, {
          size: 29
        }), /*#__PURE__*/_jsxs("span", {
          children: [" Adresse: ", Common.account.address]
        }), /*#__PURE__*/_jsx(TelephoneFill, {
          size: 29
        }), /*#__PURE__*/_jsx("span", {
          children: Common.account.mobile
        })]
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(EnvelopeAtFill, {
          size: 29
        }), /*#__PURE__*/_jsxs("span", {
          children: [" ", Common.account.email]
        }), /*#__PURE__*/_jsx(Globe, {
          size: 29
        }), /*#__PURE__*/_jsxs("span", {
          children: [" ", Common.account.website]
        })]
      })]
    })
  });
};
export default Footer;